/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_Inherit_OptionInputs */



/**
* | output |
* | --- |
* | "Everyone default" |
*
* @param {Rights_Tools_Drawer_Inherit_OptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_inherit_option = /** @type {((inputs?: Rights_Tools_Drawer_Inherit_OptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Inherit_OptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("„Alle“-Standard")
	return /** @type {LocalizedString} */ ("Everyone default")
});